import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import HtmlText from "@/sections/common/HtmlText";

// -------------------------------------------------------------------------------------------------
export type ITextCard = {
  subHeading?: string;
  heading?: string;
  description?: ReactNode;
  size?: "xsm" | "sm" | "lg" | "xlg";
};

export type ITextCardProps = HTMLAttributes<HTMLDivElement> &
  ITextCard & {
    headingClass?: string;
    subHeadingClass?: string;
    descriptionClass?: string;
    variant?: "light_primary" | "primary" | "secondary" | "white";
  };

const bgColor = {
  light_primary: "bg-primary-50",
  primary: "bg-primary-100",
  secondary: "bg-secondary-50",
  white: "bg-white",
};

const TextCard: FC<ITextCardProps> = ({
  variant = "primary",
  subHeading,
  heading,
  description,
  className,
  headingClass,
  subHeadingClass,
  descriptionClass,
}) => {
  return (
    <div
      className={clsx(
        "p-5 lg:px-8 lg:py-8 xl:px-10 xl:py-12",
        bgColor[variant],
        className,
      )}
    >
      {subHeading && (
        <span
          className={clsx(
            "mb-4 text-base font-normal text-yellow-400 xl:mb-7 xl:text-h6",
            subHeadingClass,
          )}
        >
          {subHeading}
        </span>
      )}

      {heading && (
        <h3
          className={clsx(
            "text-Black-900 mb-2 break-words text-h6 font-medium lg:mb-5 lg:text-h5 xl:text-h4",
            headingClass,
          )}
        >
          {heading}
        </h3>
      )}

      {description && (
        <HtmlText className={clsx(descriptionClass)}>{description}</HtmlText>
      )}
    </div>
  );
};

export default TextCard;
